import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getPlans,
  getCurrentSubscription,
  createCheckoutSession,
  changePlan,
  cancelSubscription,
  revertCancellation,
  cancelScheduledChange,
} from './api';

/**
 * プラン一覧を取得するフック
 */
export function usePlans() {
  return useQuery({
    queryKey: ['subscription', 'plans'],
    queryFn: getPlans,
    staleTime: 5 * 60 * 1000, // 5分キャッシュ
  });
}

/**
 * 現在の契約情報を取得するフック
 */
export function useCurrentSubscription() {
  return useQuery({
    queryKey: ['subscription', 'current'],
    queryFn: getCurrentSubscription,
    staleTime: 1 * 60 * 1000, // 1分キャッシュ
  });
}

/**
 * Checkoutセッション作成ミューテーション
 */
export function useCreateCheckout() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createCheckoutSession,
    onSuccess: (data) => {
      if (data.upgraded) {
        // アップグレード完了時はキャッシュを更新
        queryClient.invalidateQueries({ queryKey: ['subscription'] });
        queryClient.invalidateQueries({ queryKey: ['organization'] });
      }
    },
  });
}

/**
 * プラン変更（ダウングレード予約）ミューテーション
 */
export function useChangePlan() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: changePlan,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscription'] });
    },
  });
}

/**
 * 解約予約ミューテーション
 */
export function useCancelSubscription() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: cancelSubscription,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscription'] });
    },
  });
}

/**
 * 解約取り消しミューテーション（フリープランへのダウングレード予約を取り消し）
 */
export function useRevertCancellation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: revertCancellation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscription'] });
    },
  });
}

/**
 * プラン変更予約取り消しミューテーション（有料プラン間のダウングレード予約を取り消し）
 */
export function useCancelScheduledChange() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: cancelScheduledChange,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscription'] });
    },
  });
}
